export default "__VITE_ASSET__BaaV6J4h__"